import { Injectable } from '@angular/core';

import { FormTypes, ProfileFormTypes, SearchFormTypes } from 'src/app/forms/forms.enum';
import { FormAttribute } from 'src/app/interfaces/form-and-field.interface';

@Injectable()
export class FormsAttributeService {
  private readonly formsAttribute: {
    [key: string]: (type: string) => FormAttribute;
  } = {
    profile: (type: string) =>
      type === 'main'
        ? {
            type: ProfileFormTypes.BASE,
            dataTestId: `profile-${ProfileFormTypes.BASE}-form`,
          }
        : {
            type: ProfileFormTypes.PROFILE,
            dataTestId: 'profile-general-form',
          },
    individual: () => ({
      type: ProfileFormTypes.INDIVIDUAL,
      dataTestId: `profile-${ProfileFormTypes.INDIVIDUAL}-form`,
    }),
    organization: () => ({
      type: ProfileFormTypes.ORGANIZATION,
      titleId: 'ORGANIZATION_ROLE_TITLE',
      dataTestId: `profile-${ProfileFormTypes.ORGANIZATION}-form`,
    }),
    patient: () => ({
      type: ProfileFormTypes.PATIENT,
      titleId: 'PATIENT_ROLE_TITLE',
      dataTestId: `profile-${ProfileFormTypes.PATIENT}-form`,
    }),
    doctor: () => ({
      type: ProfileFormTypes.DOCTOR,
      titleId: 'GUARDIAN_DOCTOR_TITLE',
      dataTestId: `profile-${ProfileFormTypes.DOCTOR}-form`,
    }),
    med_staff: () => ({
      type: ProfileFormTypes.MED_STAFF,
      titleId: 'MED_STAFF_ROLE_TITLE',
      dataTestId: `profile-${ProfileFormTypes.MED_STAFF}-form`,
    }),
    researcher: () => ({
      type: ProfileFormTypes.RESEARCHER,
      titleId: 'RESEARCHER_ROLE_TITLE',
      dataTestId: `profile-${ProfileFormTypes.RESEARCHER}-form`,
    }),
    community: () => ({
      type: FormTypes.COMMUNITY,
      dataTestId: `${FormTypes.COMMUNITY}-form`,
    }),
    contact_us: () => ({
      type: FormTypes.CONTACT_US,
      titleId: 'CONTACT_US_FORM_TITLE',
      dataTestId: `${FormTypes.CONTACT_US}-form`,
    }),
    search: () => ({
      type: FormTypes.SEARCH,
      titleId: 'SEARCH_FIELDS_FILTER',
      dataTestId: `${FormTypes.SEARCH}-form`,
    }),
    post: () => ({
      type: FormTypes.POST,
      dataTestId: `${FormTypes.POST}-form`,
    }),
    second_auth_level: () => ({
      type: FormTypes.SECOND_AUTH_LEVEL,
      dataTestId: `${FormTypes.SECOND_AUTH_LEVEL}-form`,
    }),
    project: () => ({
      type: FormTypes.PROJECT,
      dataTestId: `${FormTypes.PROJECT}-form`,
    }),
    map_search_block: () => ({
      type: SearchFormTypes.MAP_SEARCH_BLOCK,
      dataTestId: `${SearchFormTypes.MAP_SEARCH_BLOCK}-form`,
    }),
    map_goto_block: () => ({
      type: SearchFormTypes.MAP_GOTO_BLOCK,
      dataTestId: `${SearchFormTypes.MAP_GOTO_BLOCK}-form`,
    }),
  };

  public getFormAttribute(entity: string, type = ''): FormAttribute {
    return this.formsAttribute[entity](type);
  }
}
